import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
  SET_MODEL_VARIANT_THRESHOLD_CURRENT_PAGE,
  SET_MODEL_VARIANT_THRESHOLD_PAGE_FILTER,
  MODEL_VARIANT_THRESHOLDS_MANAGEMENT_ERROR,
  GET_ALL_MODEL_VARIANT_DETAILS_THRESHOLDS,
  MODEL_VARIANT_THRESHOLDS_IS_LOADING,
  SET_MODEL_VARIANT_THRESHOLDS_DETAILS,
  SET_MODEL_VARIANT_THRESHOLDS_CHANGE,
  UPDATE_MODEL_VARIANT_THRESHOLDS_SHOW_SCREEN,
  UPDATE_MODEL_VARIANT_THRESHOLDS_SAVE_STATUS,

} from '../constants/index';

import {
  MODEL_MANAGEMENT,
  CREATE_MODEL_VARIANT_THRESHOLD,
  UPDATE_MODEL_VARIANT_THRESHOLD,
  DELETE_MODEL_VARIANT_THRESHOLD,

} from '../constants/logs';


const envName = process.env.REACT_APP_ENV_NAME_SHORT;

// Thresholds

export const setThresholdsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  messageCode = messageCode && messageCode.replace('[403]=>', '');
  dispatch(setThresholdError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setThresholdError(messageCode, false));
  }, 2500);
};

export const setThresholdError = (messageCode, status) => {
  return {
    type: MODEL_VARIANT_THRESHOLDS_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessful: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const getThresholdsThunk = (offset, limit, filter, modelId, modelVariantId, modelCategoryId, widgetCode) => dispatch => {
  if (modelVariantId) {
    dispatch(getThesholds(offset, limit, filter, modelId, modelVariantId, modelCategoryId, widgetCode));
  }
};

export const setThresholdLoadingStatus = isLoading => ({
  type: MODEL_VARIANT_THRESHOLDS_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const setThresholdShowScreenStatusThunk = status => dispatch => {
  dispatch(setThresholdShowScreenStatus(status));
};

export const setThresholdShowScreenStatus = status => ({
  type: UPDATE_MODEL_VARIANT_THRESHOLDS_SHOW_SCREEN,
  payload: { showAddEditScreen: status }
});

export const getThesholds = (offset, limit, filter, modelId, modelVariantId, modelCategoryId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/threshold`,
    data: {
      Offset: offset,
      Limit: limit,
      Filter: filter,
      ModelId: modelId,
      ModelVariantId: modelVariantId,
      ModelCategoryId: modelCategoryId
    },
    method: 'GET',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setAllThesholdListThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllThesholdListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelVariantsThresholds = (retData && retData.modelVariantsThresholds) || [];
  dispatch(setAllThresholdList(messageCode, modelVariantsThresholds));
};

export const setAllThresholdList = (messageCode, modelVariantsThresholds) => ({
  type: GET_ALL_MODEL_VARIANT_DETAILS_THRESHOLDS,
  payload: {
    data: {
      ThresholdsList: modelVariantsThresholds,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const describeThresholdThunk = (modelThresholdId, modelVariantId, modelCategoryId, widgetCode) => dispatch => {
  dispatch(describeThreshold(modelThresholdId, modelVariantId, modelCategoryId, widgetCode));
};

export const describeThreshold = (modelThresholdId, modelVariantId, modelCategoryId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/threshold/describe`,
    data: {
      ModelThresholdId: modelThresholdId || undefined,
      ModelVariantId: modelVariantId || undefined,
      ModelCategoryId: modelCategoryId || undefined
    },
    method: 'GET',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setdescribeThresholdThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setdescribeThresholdThunk = retData => dispatch => {
  dispatch(setDescribeThreshold(retData));
};

export const setDescribeThreshold = ({ retData }) => ({
  type: SET_MODEL_VARIANT_THRESHOLDS_DETAILS,
  payload: retData
});

export const setThresholdChangeThunk = retData => dispatch => {
  dispatch(setThresholdChange(retData));
};

export const setThresholdChange = retData => ({
  type: SET_MODEL_VARIANT_THRESHOLDS_CHANGE,
  payload: retData
});

export const postThresholdThunk = (modelThreshold, widgetCode) => dispatch => {
  let url = '/management/modelvariant/threshold/save';
  let actionName = modelThreshold.PerformDelete
    ? DELETE_MODEL_VARIANT_THRESHOLD
    : modelThreshold.ModelThresholdId === 0
      ? CREATE_MODEL_VARIANT_THRESHOLD
      : UPDATE_MODEL_VARIANT_THRESHOLD;

  let log = logEntry(MODEL_MANAGEMENT, actionName, modelThreshold);
  dispatch(saveThreshold(modelThreshold, url, log, widgetCode));
};

export const saveThreshold = (modelThreshold, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setThresholdStatusThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      Threshold: modelThreshold,
      log: log
    },
    widgetcode: widgetCode
  });

export const setThresholdStatusThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelVariantsThresholds = (retData && retData.modelVariantsThresholds) || [];

  dispatch(setThresholdStatusAndData(messageCode, modelVariantsThresholds, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setThresholdStatus('', false));
  }, 2500);
};

export const setThresholdStatusAndData = (messageCode, data, status) => ({
  type: UPDATE_MODEL_VARIANT_THRESHOLDS_SAVE_STATUS,
  payload: {
    data: {
      ThresholdsList: data,
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      showAddEditScreen: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setThresholdStatus = (messageCode, status) => ({
  type: UPDATE_MODEL_VARIANT_THRESHOLDS_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setCurrentPage = currentPage => ({
  type: SET_MODEL_VARIANT_THRESHOLD_CURRENT_PAGE,
  payload: { currentPage }
});

export const setPageFilter = filter => ({
  type: SET_MODEL_VARIANT_THRESHOLD_PAGE_FILTER,
  payload: { filter }
});
